import { createSlice } from '@reduxjs/toolkit';
import { emptyFetchState } from '../emptyState';
import { fetchStatus } from '../status';
import { getPublisherApps } from 'api';

// Then, handle actions in your reducers:
const publisherAppsSlice = createSlice({
  name: 'publisherApps',
  emptyFetchState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    publisherAppsFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    publisherAppsFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    publisherAppsFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    publisherAppsResetState: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  publisherAppsFetchStart,
  publisherAppsFetchSuccess,
  publisherAppsFetchFail,
  publisherAppsResetState,
} = publisherAppsSlice.actions;

// The reducer
export const publisherAppsReducer = publisherAppsSlice.reducer;

// Asynchronous thunk action
export const publisherAppsFetch = (id: string) => (dispatch) => {
  dispatch(publisherAppsFetchStart());

  getPublisherApps(id)
    .then((publisherApps) => {
      dispatch(publisherAppsFetchSuccess(publisherApps.data));
    })
    .catch((error) => {
      dispatch(publisherAppsFetchFail(error));
    });
};
